export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7369_93037)">
                <path
                    d="M4 28.3667C4 27.3357 4.83574 26.5 5.86667 26.5H13.3333C13.7015 26.5 14 26.7985 14 27.1667V27.777C14 28.1763 13.6763 28.5 13.277 28.5H4.13333C4.0597 28.5 4 28.4403 4 28.3667V28.3667Z"
                    stroke="black"
                    strokeWidth="0.96"
                />
                <path
                    d="M11.7615 26.6142C11.7615 25.6617 10.9894 24.8896 10.037 24.8896C9.08459 24.8896 8.3125 25.6617 8.3125 26.6142"
                    stroke="black"
                    strokeWidth="0.96"
                />
                <path d="M26.6317 14.727V13.2041H23.7812V14.727" stroke="black" strokeWidth="0.96" />
                <path
                    d="M28 24V15.3C28 14.8582 27.6418 14.5 27.2 14.5L23.2 14.5C19.2235 14.5 16 17.7236 16 21.7V27.054C16 27.8526 16.6474 28.5 17.446 28.5H24"
                    stroke="black"
                    strokeWidth="0.96"
                />
                <ellipse cx="23.5" cy="24" rx="4.5" ry="4.5" stroke="black" strokeWidth="0.96" />
                <circle cx="23.5" cy="24" r="1.5" stroke="black" strokeWidth="0.96" />
                <path
                    d="M9.66406 24.9543L15.6423 8.08231C16.0868 6.84051 16.9194 5.88382 17.9523 5.26292C20.763 3.57762 24.3687 4.80041 25.7585 7.79087C26.2342 8.81725 26.228 10.1351 26.2405 11.8774V12.9608"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeMiterlimit="10"
                />
                <path
                    d="M18.5703 5.11447L19.4616 7.25508M21.4005 4.77246L21.1584 6.98814M23.9943 5.73874L22.8392 7.25508M25.4578 8.11008L23.7919 8.85371"
                    stroke="black"
                    strokeWidth="0.96"
                />
                <path d="M26.0546 10.9746H24.1719" stroke="black" strokeWidth="0.96" />
            </g>
            <defs>
                <clipPath id="clip0_7369_93037">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
